import * as actionTypes from './../constants/actionTypes';
import { updateObject } from './../../utils';

const initialState = {
  renewalTypes: null,
  renewalTypesError: null,
  renewalTypesLoading: false,
  policySearchFilterStatuses: null,
  policySearchFilterStatusesError: null,
  policySearchFilterStatusesLoading: false,
  quoteSearchFilterStatuses: null,
  quoteSearchFilterStatusesError: null,
  quoteSearchFilterStatusesLoading: false,
  users: null,
  usersLoading: false,
  usersError: null,
  propertyTypes: null,
  propertyTypesError: null,
  propertyTypesLoading: false,
  serviceRequestStatuses: null,
  serviceRequestStatusesError: null,
  serviceRequestStatusesLoading: false,
  automobileLiabilityCoverageSectionTypes: null,
  automobileLiabilityCoverageSectionTypesError: null,
  automobileLiabilityCoverageSectionTypesLoading: false,
};

const getRenewalTypesStart = (state, action) => {
  return updateObject(state, {
    renewalTypesError: null,
    renewalTypesLoading: true,
  });
};

const getRenewalTypesSuccess = (state, action) => {
  return updateObject(state, {
    renewalTypes: action.renewalTypes,
    renewalTypesError: null,
    renewalTypesLoading: false,
  });
};

const getRenewalTypesFail = (state, action) => {
  return updateObject(state, {
    renewalTypes: null,
    renewalTypesError: action.error,
    renewalTypesLoading: false,
  });
};

const getPolicySearchFilterStatusesStart = (state, action) => {
  return updateObject(state, {
    policySearchFilterStatusesError: null,
    policySearchFilterStatusesLoading: true,
  });
};

const getPolicySearchFilterStatusesSuccess = (state, action) => {
  return updateObject(state, {
    policySearchFilterStatuses: action.policySearchFilterStatuses,
    policySearchFilterStatusesError: null,
    policySearchFilterStatusesLoading: false,
  });
};

const getPolicySearchFilterStatusesFail = (state, action) => {
  return updateObject(state, {
    policySearchFilterStatuses: null,
    policySearchFilterStatusesError: action.error,
    policySearchFilterStatusesLoading: false,
  });
};

const getQuoteSearchFilterStatusesStart = (state, action) => {
  return updateObject(state, {
    quoteSearchFilterStatusesError: null,
    quoteSearchFilterStatusesLoading: true,
  });
};

const getQuoteSearchFilterStatusesSuccess = (state, action) => {
  return updateObject(state, {
    quoteSearchFilterStatuses: action.quoteSearchFilterStatuses,
    quoteSearchFilterStatusesError: null,
    quoteSearchFilterStatusesLoading: false,
  });
};

const getQuoteSearchFilterStatusesFail = (state, action) => {
  return updateObject(state, {
    quoteSearchFilterStatuses: null,
    quoteSearchFilterStatusesError: action.error,
    quoteSearchFilterStatusesLoading: false,
  });
};

const getUsersStart = (state, action) => {
  return updateObject(state, {
    usersLoading: true,
  });
};

const getUsersSuccess = (state, action) => {
  return updateObject(state, {
    users: action.users,
    usersError: null,
    usersLoading: false,
  });
};

const getUsersFail = (state, action) => {
  return updateObject(state, {
    users: null,
    usersError: action.error,
    usersLoading: false,
  });
};

const getPropertyTypesStart = (state, action) => {
  return updateObject(state, {
    propertyTypesError: null,
    propertyTypesLoading: true,
  });
};

const getPropertyTypesSuccess = (state, action) => {
  return updateObject(state, {
    propertyTypes: action.data,
    propertyTypesError: null,
    propertyTypesLoading: false,
  });
};

const getPropertyTypesFail = (state, action) => {
  return updateObject(state, {
    propertyTypes: null,
    propertyTypesError: action.error,
    propertyTypesLoading: false,
  });
};

const getServiceRequestStatusesStart = (state, action) => {
  return updateObject(state, {
    serviceRequestStatusesError: null,
    serviceRequestStatusesLoading: true,
  });
};

const getServiceRequestStatusesSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestStatuses: action.serviceRequestStatuses,
    serviceRequestStatusesError: null,
    serviceRequestStatusesLoading: false,
  });
};

const getServiceRequestStatusesFail = (state, action) => {
  return updateObject(state, {
    serviceRequestStatuses: null,
    serviceRequestStatusesError: action.error,
    serviceRequestStatusesLoading: false,
  });
};

const getAutomobileLiabilityCoverageSectionTypesStart = (state, action) => {
  return updateObject(state, {
    automobileLiabilityCoverageSectionTypesError: null,
    automobileLiabilityCoverageSectionTypesLoading: true,
  });
};

const getAutomobileLiabilityCoverageSectionTypesSuccess = (state, action) => {
  return updateObject(state, {
    automobileLiabilityCoverageSectionTypes: action.data,
    automobileLiabilityCoverageSectionTypesError: null,
    automobileLiabilityCoverageSectionTypesLoading: false,
  });
};

const getAutomobileLiabilityCoverageSectionTypesFail = (state, action) => {
  return updateObject(state, {
    automobileLiabilityCoverageSectionTypes: null,
    automobileLiabilityCoverageSectionTypesError: action.error,
    automobileLiabilityCoverageSectionTypesLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_RENEWAL_TYPES_START:
      return getRenewalTypesStart(state, action);
    case actionTypes.GET_RENEWAL_TYPES_SUCCESS:
      return getRenewalTypesSuccess(state, action);
    case actionTypes.GET_RENEWAL_TYPES_FAIL:
      return getRenewalTypesFail(state, action);

    case actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_START:
      return getPolicySearchFilterStatusesStart(state, action);
    case actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_SUCCESS:
      return getPolicySearchFilterStatusesSuccess(state, action);
    case actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_FAIL:
      return getPolicySearchFilterStatusesFail(state, action);

    case actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_START:
      return getQuoteSearchFilterStatusesStart(state, action);
    case actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_SUCCESS:
      return getQuoteSearchFilterStatusesSuccess(state, action);
    case actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_FAIL:
      return getQuoteSearchFilterStatusesFail(state, action);

    case actionTypes.GET_USERS_START:
      return getUsersStart(state, action);
    case actionTypes.GET_USERS_SUCCESS:
      return getUsersSuccess(state, action);
    case actionTypes.GET_USERS_FAIL:
      return getUsersFail(state, action);

    case actionTypes.GET_PROPERTY_TYPES_START:
      return getPropertyTypesStart(state, action);
    case actionTypes.GET_PROPERTY_TYPES_SUCCESS:
      return getPropertyTypesSuccess(state, action);
    case actionTypes.GET_PROPERTY_TYPES_FAIL:
      return getPropertyTypesFail(state, action);

    case actionTypes.GET_SERVICE_REQUEST_STATUSES_START:
      return getServiceRequestStatusesStart(state, action);
    case actionTypes.GET_SERVICE_REQUEST_STATUSES_SUCCESS:
      return getServiceRequestStatusesSuccess(state, action);
    case actionTypes.GET_SERVICE_REQUEST_STATUSES_FAIL:
      return getServiceRequestStatusesFail(state, action);

    case actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_START:
      return getAutomobileLiabilityCoverageSectionTypesStart(state, action);
    case actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_SUCCESS:
      return getAutomobileLiabilityCoverageSectionTypesSuccess(state, action);
    case actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_FAIL:
      return getAutomobileLiabilityCoverageSectionTypesFail(state, action);

    default:
      return state;
  }
};

export default reducer;
